import React, { useEffect, useRef, useState } from 'react';

function Post({ parsedData }) {


    const iframeRef = useRef(null);
    const [height, setHeight] = useState("500px"); // Default balandlik

    useEffect(() => {
        const resizeIframe = () => {
            if (iframeRef.current) {
                try {
                    const newHeight = iframeRef.current.contentWindow.document.body.scrollHeight;
                    console.log(newHeight);
                    
                    setHeight(newHeight + "px");
                } catch (error) {
                    console.warn("Iframe balandligini olish imkoni yo‘q:", error);
                }
            }
        };

        setTimeout(resizeIframe, 1000); // 1 soniyadan keyin balandlikni tekshirish
    }, []);



    return (
        <div className="tg-post-card">
            <iframe ref={iframeRef} src={`https://t.me/Maktabkutubxonsirahbarxodimlari/${parsedData.messageId}?embed=1`} height={height} frameBorder={0}></iframe>
        </div>
    );
}

export default Post;